import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '../pages/pricing/index';

export const Route = createFileRoute('/pricing')({
    component: PricingPage,
});
